import React from 'react';
import { IReportSection } from './ReportSection.interface';
import styles from './ReportSection.module.scss';
import { Button } from '@zurich-primitives/button';
import { ReactComponent as ArrowIcon } from 'app/assets/Icons/Chips/Arrow.svg';

export const ReportSection: React.FC<IReportSection> = ({
  reportName,
  onReportNameChange,
  onCompareDocuments
}) => {
  return (
    <div className={styles['report-section']}>
      <div className={styles['input-container']}>
        <span className={styles.label}>Report Name</span>
        <input
          type="text"
          value={reportName}
          onChange={(e) => onReportNameChange(e.target.value)}
          className={styles['report-input']}
          placeholder={reportName}
        />
      </div>

      <Button
        onClick={onCompareDocuments}
        disabled={!reportName.trim()}
        className={styles['compare-button']}
      >
        <Button.Label>Compare Documents</Button.Label>
        <Button.Icon>
          <ArrowIcon />
        </Button.Icon>
      </Button>
    </div>
  );
};
